exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/diabetes.css"), undefined);

// module
exports.push([module.id, ".CBGDateTraceAnimated--border--3Kyho{stroke:#fff;stroke-width:.5px}", ""]);

// exports
exports.locals = {
	"border": "CBGDateTraceAnimated--border--3Kyho",
	"low": "CBGDateTraceAnimated--low--2Tj8C CBGDateTraceAnimated--border--3Kyho " + require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/diabetes.css").locals["bgLow"] + "",
	"target": "CBGDateTraceAnimated--target--Az1fN CBGDateTraceAnimated--border--3Kyho " + require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/diabetes.css").locals["bgTarget"] + "",
	"high": "CBGDateTraceAnimated--high--38Sss CBGDateTraceAnimated--border--3Kyho " + require("-!../../../../node_modules/css-loader/index.js?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!../../../../node_modules/postcss-loader/index.js!../../../styles/diabetes.css").locals["bgHigh"] + ""
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/components/trends/cbg/CBGDateTraceAnimated.css
 ** module id = 134
 ** module chunks = 0
 **/